import { supabase } from "@/integrations/supabase/client";

export type AppFeedback = {
  rating: number | null;
  pros: string | null;
  cons: string | null;
  general: string | null;
};

/**
 * Saves app feedback and notifies the team by email.
 * Pros map to `add_suggestion`, cons to `remove_suggestion`.
 */
export async function submitAppFeedback(userId: string, fb: AppFeedback) {
  const { error } = await supabase.from("feedback").insert({
    user_id: userId,
    rating: fb.rating,
    add_suggestion: fb.pros,
    remove_suggestion: fb.cons,
    general: fb.general,
  });
  if (error) return { ok: false as const, error };

  try {
    const { data: sessionData } = await supabase.auth.getSession();
    const token = sessionData.session?.access_token;
    const { data: profile } = await supabase
      .from("profiles")
      .select("full_name,email")
      .eq("id", userId)
      .maybeSingle();
    if (token) {
      await fetch("/lovable/email/transactional/send", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          templateName: "feedback-received",
          idempotencyKey: `feedback-${userId}-${Date.now()}`,
          templateData: {
            userEmail: profile?.email ?? null,
            userName: profile?.full_name ?? null,
            rating: fb.rating,
            addSuggestion: fb.pros,
            removeSuggestion: fb.cons,
            general: fb.general,
            submittedAt: new Date().toISOString(),
          },
        }),
      });
    }
  } catch (e) {
    console.error("feedback email notify failed", e);
  }

  await supabase
    .from("profiles")
    .update({
      feedback_submitted_at: new Date().toISOString(),
      last_feedback_prompt_at: new Date().toISOString(),
    })
    .eq("id", userId);

  return { ok: true as const };
}
